import React from 'react';
import {Theme} from './../elements/theme/components/theme';
import {Slideshow} from './../elements/theme/components/slideshow';

export const Home = () => {

    const carouselImages1 = [
        `${process.env.PUBLIC_URL}/assets/image2.jpg`,
        `${process.env.PUBLIC_URL}/assets/image1.jpg`,
        `${process.env.PUBLIC_URL}/assets/image2.jpg`,
        `${process.env.PUBLIC_URL}/assets/image3.jpg`,
        `${process.env.PUBLIC_URL}/assets/image2.jpg`,
    ];

    const carouselImages2 = [
        `${process.env.PUBLIC_URL}/assets/product2.jpg`,
        `${process.env.PUBLIC_URL}/assets/product1.jpg`,
        `${process.env.PUBLIC_URL}/assets/product2.jpg`,
        `${process.env.PUBLIC_URL}/assets/product3.jpg`,
        `${process.env.PUBLIC_URL}/assets/product2.jpg`,
    ];

    return (
        <Theme>
            <Slideshow
                title="Trabajos"
                images={carouselImages1}
            />
            <section className="section-services">
                <h2 className="section-services__title">Servicios</h2>
                <p className="section-services__caption">
                    Alisado semipermanente Black diva
                    <br />
                    Tratamiento de Células Madres Ybera paris
                    <br />
                    Mascarillas reconstructivas he hidratantes
                    <br />
                    Keratina, Balayage, Extensiones, Baby light.
                </p>
                <h2 className="section-services__bottom-line">Entre Otros</h2>
            </section>
            <Slideshow
                title="Productos"
                theme="dark"
                images={carouselImages2}
            />
        </Theme>
    );
};